import { render, staticRenderFns } from "./DeleteClinic.vue?vue&type=template&id=08117d13&scoped=true"
import script from "./DeleteClinic.vue?vue&type=script&lang=js"
export * from "./DeleteClinic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08117d13",
  null
  
)

export default component.exports